/**
 * @Author: Nenad Brcic
 * @Date: 27.05.16
 * @Email: neno@neno.ch
 */

import React, { PropTypes } from 'react';
import logo from '../../../images/icons/Vitra_MuseumLogo.svg';
import ToggleNav from '../shared/ToggleNav';
import styles from './Branding.scss';
import CSSModules from 'react-css-modules';

const Branding = ({ toggleNavigation, isNavigationActive, isRoot }) => (
    <p styleName="branding">
        <a href="http://www.design-museum.de" target="_blank">
            <svg styleName="logo" width="54" height="54">
                <use xlinkHref={logo} />
            </svg>
        </a>
        {
            !isRoot &&
            <ToggleNav
                toggleNavigation={toggleNavigation}
                isNavigationActive={isNavigationActive}
            />
        }
    </p>
);

Branding.propTypes = {
    toggleNavigation: PropTypes.func.isRequired,
    isNavigationActive: PropTypes.bool.isRequired,
    isRoot: PropTypes.bool.isRequired,
};

export default CSSModules(Branding, styles);


// WEBPACK FOOTER //
// ./app/components/Branding/index.jsx